import { TagList } from '@mews-commander/ui';
import { Container } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { compactArray } from '@mews/fp';
import { useGetServiceNamesByIdQuery } from '../queries/useGetServiceNamesByIdQuery';

interface ServicesCellProps {
    serviceIds: string[];
}

const VISIBLE_TAGS_COUNT = 5;

export const ServicesCell = ({ serviceIds }: ServicesCellProps) => {
    const { data: serviceNamesById } = useGetServiceNamesByIdQuery();
    const services = serviceIds.map((id) => serviceNamesById[id]).toSorted();

    const visibleServiceTags = compactArray([
        ...services.slice(0, VISIBLE_TAGS_COUNT),
        services.length > VISIBLE_TAGS_COUNT
            ? `${UnicodeEntity.PlusSign}${services.length - VISIBLE_TAGS_COUNT}`
            : undefined,
    ]);

    return (
        <Container maxHeight="160px">
            <TagList tagsVariant="basicSubtle" tags={visibleServiceTags} />
        </Container>
    );
};
